import { toast } from "react-toastify";
import { duaYKienDonNghiPhep, duyetDonNghiPhep, huyDonNghiPhep, layChiTiet, layDsNghiPhepTrongNamTheoNhanVien, thuHoiNghiPhep, xoaDonNghiPhep, yeuCauHuyNghiPhep } from "../../services/donnghiphep";
import { useEffect, useState } from 'react';
import { ContentHeader } from "../../components";
import { Col, Row, Tabs, FloatButton, Tag, Button, Space, Form, Input, Radio, Table } from "antd";
import { dateCommon, validateMessages } from "../../helpers/common";
import { Links } from "../../helpers/Links";
import { EditOutlined, DeleteOutlined, DownloadOutlined, CheckOutlined, CloseOutlined, SendOutlined, UndoOutlined, CloseCircleFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import ModalTextForm from "../../components/modal/ModalTextForm";
import { useDispatch, useSelector } from "react-redux";
import { DonNghiPhep } from "@app/models/donnghiphep/DonNghiPhep";
import { NgayPhepTrongNam } from '@app/models/donnghiphep/NgayPhepTrongNam';
import { hideLoadingScreen, showLoadingScreen } from "@app/store/reducers/loading";
import { loaiNghiPhep, trangThaiDonNghiPhep } from "../../constants";
import { xuatDonNghiPhep } from "../../services/report";
import { useForm } from 'antd/es/form/Form';
import LogNguoiDungTable from "../utils/LogNguoiDungTable";
const { TextArea } = Input;

const XemDonNghiPhep = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const params = new URLSearchParams(window.location.search)
    let id = params.get('id') || '0';
    const user = useSelector((state: any) => state.auth.currentUser);
    const [data, setData] = useState<DonNghiPhep>(new DonNghiPhep);
    const [trangThaiTag, setTrangThaiTag] = useState<JSX.Element>();
    const [openModalXoa, setOpenModalXoa] = useState(false);
    const [openModalDuyet, setOpenModalDuyet] = useState(false);
    const [openModalTuChoi, setOpenModalTuChoi] = useState(false);
    const [openModalDuyetHuy, setOpenModalDuyetHuy] = useState(false);
    const [openModalTuChoiHuy, setOpenModalTuChoiHuy] = useState(false);
    const [openModalYKien, setOpenModalYKien] = useState(false);
    const [lyDoTuChoi, setLyDoTuChoi] = useState<string>("");
    const [reload, setReload] = useState(false);
    const [dsNgayPhepTrongNam, setDSNgayPhepTrongNam] = useState<Array<NgayPhepTrongNam>>([]);
    const [noiDungYKien1, setNoiDungYKien1] = useState<string>("");
    const [noiDungYKien2, setNoiDungYKien2] = useState<string>("");
    const [noiDungYKien3, setNoiDungYKien3] = useState<string>("");
    const [noiDungPheDuyet, setNoiDungPheDuyet] = useState<string>("");
    const [formDuaYKien] = useForm();
    const [openModalThuHoi, setOpenModalThuHoi] = useState(false);
    const [openModalYeuCauHuy, setOpenModalYeuCauHuy] = useState(false);
    const [enabledYK2, setEnabledYK2] = useState(false);
    const [enabledYK3, setEnabledYK3] = useState(false);
    const layCT = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            if (id > 0) {
                var data = await layChiTiet(id);
                setData(data);
                switch (data.trangThai) {
                    case trangThaiDonNghiPhep.khoiTao: setTrangThaiTag(<Tag color="processing">Khởi tạo</Tag>); break;
                    case trangThaiDonNghiPhep.trinh: setTrangThaiTag(<Tag color="warning">Trình Lãnh đạo</Tag>); break;
                    case trangThaiDonNghiPhep.daDuyet: setTrangThaiTag(<Tag color="success">Đã Duyệt</Tag>); break;
                    case trangThaiDonNghiPhep.tuChoi: setTrangThaiTag(<Tag color="error">Từ chối</Tag>); break;
                    case trangThaiDonNghiPhep.yKien: setTrangThaiTag(<Tag color="orange">Lấy ý kiến</Tag>); break;
                    case trangThaiDonNghiPhep.yeuCauHuy: setTrangThaiTag(<Tag color="cyan">Yêu cầu hủy</Tag>); break;
                    case trangThaiDonNghiPhep.daHuy: setTrangThaiTag(<Tag color="error">Đã hủy</Tag>); break;
                }
                if (data.idLoaiNghiPhep == loaiNghiPhep.nghiPhep) {
                    var rs = await layDsNghiPhepTrongNamTheoNhanVien(data.tuNgay, data.denNgay, data.idNhanVien);
                    if (rs == null) {
                        setDSNgayPhepTrongNam([]);
                    } else {
                        setDSNgayPhepTrongNam(rs);
                    }
                }
                if (data.idLoaiNghiPhep == loaiNghiPhep.nghiKhongLuong || data.idLoaiNghiPhep == loaiNghiPhep.nghiThaiSan || data.idLoaiNghiPhep == loaiNghiPhep.nghiOm || data.idLoaiNghiPhep == loaiNghiPhep.nghiBHXH) {
                    if (data.idNguoiYKien2 != null) {
                        setEnabledYK2(true);
                    }
                    if (data.idLoaiNghiPhep == loaiNghiPhep.nghiBHXH && data.idNguoiYKien3 != null) {
                        setEnabledYK3(true);
                    }
                }
                var ndYKien1 = data.logs.filter((item) => item.idNguoiDung == data.idNguoiYKien1)
                if (ndYKien1.length > 0) {
                    setNoiDungYKien1(ndYKien1[ndYKien1.length - 1].chiTiet)
                }
                var ndYKien2 = data.logs.filter((item) => item.idNguoiDung == data.idNguoiYKien2)
                if (ndYKien2.length > 0) {
                    setNoiDungYKien2(ndYKien2[ndYKien2.length - 1].chiTiet)
                } 
                var ndYKien3 = data.logs.filter((item) => item.idNguoiDung == data.idNguoiYKien3)
                if (data.idNguoiYKien2 == data.idNguoiYKien3 || data.idNguoiYKien1 == data.idNguoiYKien3 ) {
                    if (ndYKien3.length > 1) {
                        setNoiDungYKien3(ndYKien3[0].chiTiet)
                    }
                } else {
                    if (ndYKien3.length > 0) {
                        setNoiDungYKien3(ndYKien3[0].chiTiet)
                    }
                }
                var ndPheDuyet = data.logs.filter((item) => item.idNguoiDung == data.idNguoiDuyet)
                if (ndPheDuyet.length > 0) {
                    setNoiDungPheDuyet(ndPheDuyet[0].chiTiet)
                }
            }
        }
        catch (error: any) {
            toast.error("Đơn nghỉ phép không tồn tại hoặc bạn không có quyền xem!");
            navigate(Links.Phep.DanhSachDangKy);
        }
        dispatch(hideLoadingScreen());
    }

    const xoa = async () => {
        try {
            dispatch(showLoadingScreen());
            await xoaDonNghiPhep(parseInt(id));
            dispatch(hideLoadingScreen());
            setOpenModalXoa(false);
            toast.success('Xóa đơn nghỉ phép thành công');
            navigate(Links.Phep.DanhSachDangKy);
        }
        catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error('Xóa đơn nghỉ phép không thành công! Vui lòng thử lại.');
        };
    };

    const eventPheDuyet = async (duyet: boolean) => {
        try {
            await duyetDonNghiPhep({
                id: data.id,
                isDuyet: duyet,
                noiDung: lyDoTuChoi
            });
            toast.success("Phê duyệt đơn nghỉ phép thành công.");
            setReload(true);
        } catch (error: any) {
            toast.error(error);
        }
    }

    const eventPheDuyetHuy = async (duyet: boolean) => {
        try {
            await huyDonNghiPhep({
                id: data.id,
                isDuyet: duyet,
                noiDung: lyDoTuChoi
            });
            toast.success("Phê duyệt yêu cầu hủy đơn nghỉ phép thành công.");
            setReload(true);
        } catch (error: any) {
            toast.error(error);
        }
    }

    const onDuaYKien = async () => {
        formDuaYKien.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            try {
                await duaYKienDonNghiPhep({
                    id: data.id,
                    isDuyet: values.duyet,
                    noiDung: values.noiDung || ""
                });
                toast.success("Đưa ý kiến thành công.");
                setReload(true);
            } catch (ex: any) {
                toast.error(ex);
            }

            dispatch(hideLoadingScreen());
        }).catch(() => {

            dispatch(hideLoadingScreen());
        })
    }

    const xuatBaoCao = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            var response = await xuatDonNghiPhep(id);
            let link = document.createElement('a');

            link.download = data.tenNhanVien + `-Phep.docx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            dispatch(hideLoadingScreen());
        } catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error(error || 'Có lỗi xảy ra');
        }
    }

    const eventThuHoiNghiPhep = async () => {
        try {
            await thuHoiNghiPhep(data.id);
            dispatch(hideLoadingScreen());
            setReload(true);
            setOpenModalThuHoi(false);
            toast.success("Thu hồi đơn nghỉ phép thành công.");
        } catch (error: any) {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        }
    }

    const eventYeuCauHuyNghiPhep = async () => {
        try {
            await yeuCauHuyNghiPhep(data.id);
            dispatch(hideLoadingScreen());
            setReload(true);
            setOpenModalYeuCauHuy(false);
            toast.success("Yêu cầu hủy đơn nghỉ phép thành công.");
        } catch (error: any) {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        }
    }

    useEffect(() => {
        if (parseInt(id) > 0) {
            layCT(parseInt(id));
        }
    }, []);

    useEffect(() => {
        if (reload) {
            if (parseInt(id) > 0) {
                layCT(parseInt(id));
            }
            setReload(false);
        }
    }, [reload]);
    return (
        <section style={{ paddingBottom: "60px" }}>
            <ContentHeader title="Đơn nghỉ phép" />
            {openModalXoa && <ModalTextForm show={openModalXoa}
                title="Xoá đơn nghỉ phép"
                handleClose={() => setOpenModalXoa(false)}
                handleSave={() => xoa()}>
                Bạn có đồng ý xóa đơn nghỉ phép này không?
            </ModalTextForm>}
            {openModalThuHoi && <ModalTextForm show={openModalThuHoi}
                title="Thu hồi đơn nghỉ phép"
                handleClose={() => setOpenModalThuHoi(false)}
                handleSave={() => eventThuHoiNghiPhep()}>
                Bạn có muốn thu hồi đơn nghỉ phép này không?
            </ModalTextForm>}
            {openModalYeuCauHuy && <ModalTextForm show={openModalYeuCauHuy}
                title="Yêu cầu hủy đơn nghỉ phép"
                handleClose={() => setOpenModalYeuCauHuy(false)}
                handleSave={() => eventYeuCauHuyNghiPhep()}>
                Bạn có muốn gửi yêu cầu hủy đơn nghỉ phép này không?
            </ModalTextForm>}
            {openModalDuyet && <ModalTextForm show={openModalDuyet}
                title="Đồng ý phê duyệt đơn nghỉ phép"
                handleClose={() => setOpenModalDuyet(false)}
                handleSave={() => { eventPheDuyet(true); setOpenModalDuyet(false); }}>
                <Row>
                    <Col span="24">
                        Bạn có muốn <label>Đồng ý </label> phê duyệt đơn nghỉ phép này không? Hãy nhập nội dung (nếu có):
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        <TextArea rows={2} value={lyDoTuChoi} onChange={(e) => { setLyDoTuChoi(e.target.value); }} />
                    </Col>
                </Row>
            </ModalTextForm>}
            {openModalTuChoi && <ModalTextForm show={openModalTuChoi}
                title="Từ chối phê duyệt đơn nghỉ phép"
                handleClose={() => setOpenModalTuChoi(false)}
                handleSave={() => { eventPheDuyet(false); setOpenModalTuChoi(false); }}>
                <Row>
                    <Col span="24">
                        Bạn có muốn <label>Từ chối</label> phê duyệt đơn nghỉ phép này không? Hãy nhập lý do (nếu có):
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        <TextArea rows={2} value={lyDoTuChoi} onChange={(e) => { setLyDoTuChoi(e.target.value); }} />
                    </Col>
                </Row>
            </ModalTextForm>}
            {openModalDuyetHuy && <ModalTextForm show={openModalDuyetHuy}
                title="Đồng ý phê duyệt yêu cầu hủy đơn nghỉ phép"
                handleClose={() => setOpenModalDuyetHuy(false)}
                handleSave={() => { eventPheDuyetHuy(true); setOpenModalDuyetHuy(false); }}>
                <Row>
                    <Col span="24">
                        Bạn có muốn <label>Đồng ý </label> phê duyệt yêu cầu hủy đơn nghỉ phép này không? Hãy nhập nội dung (nếu có):
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        <TextArea rows={2} value={lyDoTuChoi} onChange={(e) => { setLyDoTuChoi(e.target.value); }} />
                    </Col>
                </Row>
            </ModalTextForm>}
            {openModalTuChoiHuy && <ModalTextForm show={openModalTuChoiHuy}
                title="Từ chối yêu cầu hủy đơn nghỉ phép"
                handleClose={() => setOpenModalTuChoiHuy(false)}
                handleSave={() => { eventPheDuyetHuy(false); setOpenModalTuChoiHuy(false); }}>
                <Row>
                    <Col span="24">
                        Bạn có muốn <label>Từ chối</label> yêu cầu hủy đơn nghỉ phép này không? Hãy nhập lý do (nếu có):
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        <TextArea rows={2} value={lyDoTuChoi} onChange={(e) => { setLyDoTuChoi(e.target.value); }} />
                    </Col>
                </Row>
            </ModalTextForm>}
            {openModalYKien && <ModalTextForm show={openModalYKien}
                title="Đưa ý kiến cho đơn nghỉ phép"
                handleClose={() => setOpenModalYKien(false)}
                handleSave={() => { onDuaYKien(); setOpenModalYKien(false); }}>
                <Form
                    form={formDuaYKien}
                    onFinish={() => { }}
                    validateMessages={validateMessages}
                    initialValues={{
                        'duyet': true,
                        'noiDung': "",
                    }}
                >
                    <Form.Item label="Ý kiến" name="duyet" rules={[{ required: true }]}>
                        <Radio.Group>
                            <Radio value={true}>Đồng ý</Radio>
                            <Radio value={false}>Từ chối</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item
                        label="Nội dung ý kiến"
                        name="noiDung"
                    >
                        <TextArea placeholder="Nội dung" />
                    </Form.Item>
                </Form>
            </ModalTextForm>}
            <Space style={{ position: "fixed", zIndex: 1, right: "24px", top: "100px" }} >
                {
                    data.quyenPheDuyet
                    && <>
                        <Button type="primary" className="float-right hrm-btn-delete" htmlType="button" icon={<CloseOutlined rev="" />}
                            onClick={() => {
                                setLyDoTuChoi("");
                                setOpenModalTuChoi(true);
                            }}
                        >
                            Không duyệt
                        </Button>
                        <Button type="primary" className="float-right" htmlType="button" icon=<CheckOutlined rev="" />
                            onClick={() => { setLyDoTuChoi(""); setOpenModalDuyet(true); }}>
                            Duyệt
                        </Button>
                    </>
                }
                {
                    data.quyenHuy
                    && <>
                        <Button type="primary" className="float-right hrm-btn-delete" htmlType="button" icon={<CloseOutlined rev="" />}
                            onClick={() => {
                                setLyDoTuChoi("");
                                setOpenModalTuChoiHuy(true);
                            }}
                        >
                            Từ chối
                        </Button>
                        <Button type="primary" className="float-right" htmlType="button" icon=<CheckOutlined rev="" />
                            onClick={() => { setLyDoTuChoi(""); setOpenModalDuyetHuy(true); }}>
                            Đồng ý
                        </Button>
                    </>
                }
                {
                    data.quyenYKien &&
                    <Button
                        type="primary"
                        icon={<SendOutlined rev="" />}
                        onClick={() => { setOpenModalYKien(true); }}
                    >
                        Đưa ý kiến
                    </Button>
                }
                {
                    (data.trangThai == trangThaiDonNghiPhep.trinh || data.trangThai == trangThaiDonNghiPhep.yKien) && data.idNhanVien == user.idNhanVien &&
                    <Button
                        type="primary"
                        className="hrm-btn-warning"
                        icon={<UndoOutlined rev="" />}
                        onClick={() => {
                            setOpenModalThuHoi(true);
                        }}
                    >
                        Thu hồi
                    </Button>
                }
                {
                   data.trangThai == trangThaiDonNghiPhep.daDuyet && data.idNhanVien == user.idNhanVien &&
                    <Button
                        type="primary"
                        className="hrm-btn-delete"
                        icon={<CloseCircleFilled rev="" />}
                        onClick={() => {
                            setOpenModalYeuCauHuy(true);
                        }}
                    >
                        Yêu cầu hủy
                    </Button>
                }
            </Space>
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Tabs defaultActiveKey="1" items={[
                            {
                                key: '1',
                                label: <span>Thông tin </span>,
                                children:
                                    <Row>
                                        <Col span="24" className="card card-body">
                                            <Row gutter={24}>
                                                <Col span={8}>
                                                    <div>Trạng thái</div>
                                                    <label>{trangThaiTag}</label>
                                                </Col>
                                                <Col span={8}>
                                                    <div>Ngày tạo</div>
                                                    <label>{dateCommon.formatDate(data?.ngayKhoiTao)}</label>
                                                </Col>
                                                {
                                                    data?.ngayCapNhat != null &&
                                                    <Col span={8}>
                                                        <div>Ngày cập nhật</div>
                                                        <label>{dateCommon.formatDate(data?.ngayCapNhat)}</label>
                                                    </Col>
                                                }
                                            </Row>
                                            <Row gutter={24}>
                                                <Col span={8}>
                                                    <div>Nhân viên</div>
                                                    <label>{data?.tenNhanVien + " - " + data?.tenDonVi}</label>
                                                </Col>
                                                <Col span={8}>
                                                    <div>
                                                        <div>Loại nghỉ</div>
                                                        <label>{data?.tenLoaiNghiPhep}</label>
                                                    </div>
                                                </Col>
                                                <Col span={8}>
                                                    <div>Địa điểm nghỉ phép</div>
                                                    <label>
                                                        {data?.diaDiemNghiPhep}
                                                    </label>
                                                </Col>
                                            </Row>
                                            <Row gutter={24}>
                                                <Col span={8}>
                                                    <div>Kính gửi</div>
                                                    <label>{data?.kinhGui}</label>
                                                </Col>
                                                <Col span={16}>
                                                    <div>Lý do</div>
                                                    <label>
                                                        {data?.lyDo}
                                                    </label>
                                                </Col>
                                            </Row>
                                            <Row gutter={24}>
                                                <Col span={8}>
                                                    <div>{enabledYK2 ? "Người ý kiến 1" : "Người ý kiến"}</div>
                                                    <label>
                                                        {data?.idNguoiYKien1 != null ? data?.tenNguoiYKien1 : "Không có"}
                                                    </label>
                                                </Col>
                                                {
                                                    enabledYK2 &&
                                                    <Col span={8}>
                                                        <div>Người ý kiến 2</div>
                                                        <label>
                                                            {data?.idNguoiYKien2 != null ? data?.tenNguoiYKien2 : "Không có"}
                                                        </label>
                                                    </Col>
                                                }
                                                {
                                                    enabledYK3 &&
                                                    <Col span={8}>
                                                        <div>BCH Công đoàn</div>
                                                        <label>
                                                            {data?.idNguoiYKien3 != null ? data?.tenNguoiYKien3 : "Không có"}
                                                        </label>
                                                    </Col>
                                                }
                                                <Col span={8}>
                                                    <div>Người duyệt</div>
                                                    <label>{data?.tenNguoiDuyet}</label>
                                                </Col>
                                            </Row>
                                            <Row gutter={24}>
                                                <Col span={8}>
                                                    <div>Từ ngày</div>
                                                    <label>{dateCommon.formatDate(data?.tuNgay)}</label>
                                                </Col>
                                                <Col span={8}>
                                                    <div>Đến ngày</div>
                                                    <label>{dateCommon.formatDate(data?.denNgay)}</label>
                                                </Col>
                                                <Col span={8}>
                                                    <div>Tổng số ngày nghỉ</div>
                                                    <label>{data?.tongSoNgayNghi}</label>
                                                </Col>
                                            </Row>
                                            {
                                                data.idLoaiNghiPhep == loaiNghiPhep.nghiPhep && dsNgayPhepTrongNam.length >= 1
                                                    ? <>{data?.tongSoNgayNghi_NamNay > 0 && <Row gutter={24}>
                                                        <Col span="8">
                                                            <div>Số ngày phép được phân bổ trong năm {data?.namNay}</div>
                                                            <label>{dsNgayPhepTrongNam[0].soNgayPhepTrongNam}</label>
                                                        </Col>
                                                        <Col span="8">
                                                            <div>Số ngày đã nghỉ phép (năm {data?.namNay})</div>
                                                            <label>{data?.soNgayDaNghi_NamNay}</label>
                                                        </Col>
                                                        <Col span="8">
                                                            <div>Số ngày phép còn lại (năm {data?.namNay}) </div>
                                                            <label> {(dsNgayPhepTrongNam[0].soNgayPhepTrongNam - data?.soNgayDaNghi_NamNay)}</label>
                                                        </Col>
                                                    </Row>}
                                                        {
                                                            data?.tongSoNgayNghi_NamTruoc > 0 && dsNgayPhepTrongNam.length > 1 &&
                                                            <Row gutter={24}>
                                                                <Col span="8">
                                                                    <div>Số ngày phép được phân bổ trong năm {data?.namTruoc}</div>
                                                                    <label>{dsNgayPhepTrongNam[1].soNgayPhepTrongNam}</label>
                                                                </Col>
                                                                <Col span="8">
                                                                    <div>Số ngày đã nghỉ phép (năm {data?.namTruoc})</div>
                                                                    <label> {data?.soNgayDaNghi_NamTruoc}</label>
                                                                </Col>
                                                                <Col span="8">
                                                                    <div>Số ngày phép còn lại (năm {data?.namTruoc})</div>
                                                                    <label> {(dsNgayPhepTrongNam[1].soNgayPhepTrongNam - data?.soNgayDaNghi_NamTruoc)}</label>
                                                                </Col>
                                                            </Row>
                                                        }</>
                                                    : null
                                            }
                                            <Row gutter={24}>
                                                {noiDungYKien1 != "" && noiDungYKien1 != null &&
                                                    <Col span="8">
                                                        <div>{noiDungYKien2 != "" && noiDungYKien2 != null ? "Nội dung ý kiến 1" : "Nội dung ý kiến"}</div>
                                                        <label>{noiDungYKien1}</label>
                                                    </Col>
                                                }
                                                {noiDungYKien2 != "" && noiDungYKien2 != null &&
                                                    <Col span="8">
                                                        <div>Nội dung ý kiến 2</div>
                                                        <label>{noiDungYKien2}</label>
                                                    </Col>
                                                }
                                                {noiDungYKien3 != "" && noiDungYKien3 != null &&
                                                    <Col span="8">
                                                        <div>Ý kiến BCH Công đoàn</div>
                                                        <label>{noiDungYKien3}</label>
                                                    </Col>
                                                }
                                                {noiDungPheDuyet != "" && noiDungPheDuyet != null &&
                                                    <Col span="8">
                                                        <div>Nội dung phê duyệt</div>
                                                        <label>{noiDungPheDuyet}</label>
                                                    </Col>
                                                }
                                            </Row>
                                        </Col>
                                    </Row>
                            },
                            {
                                key: '2',
                                label: "Lịch sử thao tác",
                                children: <LogNguoiDungTable data={data?.logs} />
                            },
                        ]}>
                        </Tabs>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="card-outline">

                        <Row className="mt-1 mb-1">
                            <Col span="24">
                                <FloatButton.Group
                                    trigger="hover"
                                    type="primary"
                                    style={{ right: 50, bottom: 80 }}
                                > {data.quyenSua &&
                                    <>
                                        <FloatButton
                                            tooltip="Chỉnh sửa đơn nghỉ phép"
                                            className="hrm-btn-warning"
                                            icon={<EditOutlined rev="" />}
                                            onClick={() => {
                                                navigate(Links.Phep.ChiTiet + "?id=" + id);
                                            }}
                                        />
                                        <FloatButton
                                            tooltip="Xóa đơn nghỉ phép"
                                            className="hrm-btn-delete"
                                            icon={<DeleteOutlined rev="" />}
                                            onClick={() => setOpenModalXoa(true)}
                                        />
                                    </>
                                    }
                                    <FloatButton
                                        tooltip="Tải đơn nghỉ phép"
                                        className="hrm-btn-success"
                                        icon={<DownloadOutlined rev="" />}
                                        onClick={() => { xuatBaoCao(data.id) }}
                                    />
                                </FloatButton.Group>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </section>
    )
}

export default XemDonNghiPhep;